import React, { Component } from "react";
import { getSideName } from "./../common/sideNameBuilder";

class Standings extends Component {
  state = {};

  render() {
    return (
      <div className="mt-4 container-md">
        <h2 className="text-center">Standings:</h2>
        <div className="row">
          <div className="col">
            <table className="table table-hover table-sm">
              <thead className="table-primary">
                <tr>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col">Points</th>
                  <th scope="col">TieBreak</th>
                  <th scope="col">Played</th>
                </tr>
              </thead>
              <tbody>
                {this.props.standings.map((s) => {
                  return (
                    <tr key={s.rank}>
                      <th>{s.rank}</th>
                      <td className="pr-4 pl-4">{getSideName(s.sideName)}</td>
                      <td className="text-right">{s.points}</td>
                      <td className="text-right">{s.tieBreak}</td>
                      <td className="text-right">{s.played}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default Standings;
